import { BasicAddExtraCurrencyCommand, AddExtraCurrencyVO, BasicController, PathProvider, BrowserUtil, EnvGlobalsHandler, BasicPaymentShopClickTrackingVO, CommandController } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { URLRequest, ExternalInterface } from "@goodgamestudios/createjs-utilities";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";
import { Poker2Model } from "../../model/Poker2Model";

import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("Poker2AddExtraCurrencyCommand");

export class Poker2AddExtraCurrencyCommand extends BasicAddExtraCurrencyCommand {
    public execute(commandVars: any = null): void {
        // We need to be sure, that user is logged in the game
        if (!Poker2Model.sessionData.loggedIn) {
            return;
        }

        // sessionId is used as a shop-key in the link and tracked in GamePaymentShopClickEvent.
        // aka clientTime
        // aka shopId
        this.sessionId = this.getCurrentUnixTime();

        let currentHash: string;
        let clickSourceId: number = 0;
        let shopTab: number = 0;

        // To be sure, that new "Tracking of the shop click source" feature don't break any shop functionality of the legacy games,
        // AddExtraCurrency command can be use with a paymentHash (as earlier).
        if (!commandVars) {
            currentHash = "";
        } else if (commandVars instanceof AddExtraCurrencyVO) {
            currentHash = commandVars.paymentHash;
            clickSourceId = int(commandVars.clickSourceId);
            shopTab = int(commandVars.shopTab);
        } else {
            currentHash = commandVars.toString();
        }

        this.paymentHash = currentHash;

        // GamePaymentShopClickEvent fires, if user clicks on the shop-button.
        CommandController.instance.executeCommand(BasicController.COMMAND_TRACK_GAME_PAYMENT_SHOP_CLICK_EVENT, new BasicPaymentShopClickTrackingVO(this.sessionId, clickSourceId));

        Poker2LayoutManager.getInstance().revertFullscreen();

        let env = EnvGlobalsHandler.globals;

        //use Shop in SocialNetwork
        if (env.requestPayByJS) {
            if(!ExternalInterface.available) {
                return;
            }
            try {
                ExternalInterface.call("requestPayment");
            } catch (e) {
                logger.error(`Can't open external shop: ${e.message}`);
            }
        } else { //use WWW Shop
            /* generating single hash format coming from shop and server */
            let lang = PathProvider.instance.shopURL.match(/\/([a-zA-Z\-]+)\/$/)[1];
            // let urlRequest: URLRequest = new URLRequest(PathProvider.instance.shopURL + this.paymentHash);
            let urlRequest: URLRequest = new URLRequest(`https://shop${env.isTest ? '-test' : ''}.goodgamestudios.com/`);
            let urlVariables: any = {
                sid: this.sessionId,
                lng: lang,
                gId: env.gameId,
                nId: env.networkId,
                iId: window.ggs.worldAssignment.facade.selectedNetworkInstance.instanceId,
                key: this.paymentHash
            };

            if (shopTab > 0) {
                urlVariables.t = shopTab;
            }

            urlRequest.data = urlVariables;

            BrowserUtil.openWindow(urlRequest);
        }
    }

    // TODO: Isn't there a global util class for retrieving the unix time?
    private getCurrentUnixTime(): number {
        let dateStamp: Date = new Date();
        return Date.UTC(dateStamp.getUTCFullYear(), dateStamp.getUTCMonth(), dateStamp.getUTCDate(), dateStamp.getUTCHours(), dateStamp.getUTCMinutes(), dateStamp.getUTCSeconds(), dateStamp.getUTCMilliseconds()).valueOf();
    }

}
